/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumLinkIcons, HydrusLinkFragment, HydrusColumnFragment } from "@cosmos/hygraph-schema";
import { CosmosLink, CosmosText, EdsIcon } from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { Tag } from "@eds-web/react/Tag";

const column = css({
	padding: "eds.dimension.24",
	flex: "1",
});

const text = css({
	display: "flex",
	alignItems: "center",
	width: "full",
	borderRadius: "eds.borderRadius.8",
	padding: "eds.dimension.8",
	textAlign: "start",
	"& .cosmos-text": {
		lineClamp: "1",
		overflow: "hidden",
	},
});

const columnTitle = css({
	gap: "eds.dimension.4",
	"& svg": {
		minWidth: "eds.dimension.24",
		minHeight: "eds.dimension.24",
	},
});

const columnItem = css({
	gap: "eds.dimension.8",
});

const columnLink = css({
	"&:hover": {
		backgroundColor: "eds.palette.transparent.elevated.high.hover",
		"& .hydrus-link-icon svg": {
			fill: "eds.icon.primary!important", // override EDS style
		},
		"& .hydrus-heading-chevron svg": {
			transform: "translatex(6px)",
		},
	},
	"& .hydrus-heading-chevron svg": {
		transform: "translatex(0px)",
		transition: "transform token(animations.eds.duration.100) token(animations.eds.easing.easeInOutQuad)",
	},
});

export function HydrusColumn({
	title,
	titleHref,
	links,
}: HydrusColumnFragment & { animate?: boolean }): React.JSX.Element | null {
	if (!links.length && !title) return null;
	return (
		<VStack className={cx("hydrus-column", column)} alignItems="flex-start" gap="0">
			{title ? (
				<CosmosLink className={cx(text, columnTitle, titleHref ? columnLink : undefined)} href={titleHref || ""}>
					<CosmosText variant="headingSM" as="h3">
						{title}
					</CosmosText>
					{titleHref ? (
						<div className="hydrus-link-icon hydrus-heading-chevron">
							<EdsIcon size="sm" icon={CosmosEnumLinkIcons.ChevronRight} color="secondary" />
						</div>
					) : null}
				</CosmosLink>
			) : null}
			{links?.length
				? links.map((link: HydrusLinkFragment, i) => (
						<CosmosLink
							key={`hydrus-link-${i}`}
							className={cx(text, columnItem, link.href ? columnLink : undefined)}
							href={link.href || ""}
							analytics={{
								eventCategory: "hyperlink",
								eventLabel: link.label || "",
								eventValue: {
									component: "TextLinkAndChevron",
									icon: link.icon,
									href: link.href,
								},
							}}
						>
							{link.icon ? (
								<div className="hydrus-link-icon">
									<EdsIcon size="sm" icon={link.icon} color="secondary" />
								</div>
							) : null}
							<CosmosText variant="uiMD">{link.label}</CosmosText>
							{link.badgeLabel ? <Tag size="sm" label={link.badgeLabel} /> : null}
						</CosmosLink>
					))
				: null}
		</VStack>
	);
}
